import { SVGProps, Ref, forwardRef } from 'react';

export const SpeedometerOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M12 5c1.065 0 1.987.144 2.778.403l-1.49 1.49A8.3 8.3 0 0 0 12 6.8c-2.192 0-3.394.71-4.086 1.54C7.174 9.228 6.8 10.517 6.8 12c0 1.036.183 1.979.546 2.755l-1.33 1.33C5.298 14.887 5 13.443 5 12c0-3.5 1.75-7 7-7"
                fill="currentColor"
            />
            <path
                d="M17.2 12q0-.67-.101-1.28l1.484-1.485c.29.876.417 1.82.417 2.765 0 1.443-.298 2.887-1.016 4.085l-1.33-1.33c.363-.777.546-1.719.546-2.755"
                fill="currentColor"
            />
            <path
                d="m13.922 11.35 4.714-4.714-1.272-1.272-4.711 4.71A2.7 2.7 0 0 0 12 10c-1.5 0-2 1-2 2s.5 2 2 2 2-1 2-2c0-.22-.024-.44-.078-.65"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 12C1 6.5 3.75 1 12 1s11 5.5 11 11-2.75 11-11 11S1 17.5 1 12m1.8 0c0-2.483.624-4.772 1.989-6.41C6.106 4.01 8.308 2.8 12 2.8s5.894 1.21 7.211 2.79C20.576 7.228 21.2 9.517 21.2 12s-.624 4.772-1.989 6.41C17.894 19.99 15.692 21.2 12 21.2s-5.894-1.21-7.211-2.79C3.424 16.772 2.8 14.483 2.8 12"
                fill="currentColor"
            />
        </g>
    </svg>
));
SpeedometerOutlinedSize24Glyph.displayName = 'SpeedometerOutlinedSize24Glyph';
